import querystring from 'query-string'
import Cookies from 'universal-cookie'

import * as types from './constants'
import { API_HOSTNAME } from '../../GlobalConfig'

const cookies = new Cookies()
const opts = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  mode: 'cors',
}

export const getEventLists = (options) => {
  const qs = querystring.stringify(options)

  return {
    types: types.GET_EVENT_LISTS,
    promise: fetch(`${API_HOSTNAME}/v1/eventmina?${qs}`),
  }
}

export const getSubeventLists = (options) => {
  const qs = querystring.stringify(options)
  return {
    types: types.GET_SUBEVENT_LISTS,
    promise: fetch(`${API_HOSTNAME}/v1/eventmina?${qs}`),
  }
}

export const loadMoreEvents = (options) => {
  const qs = querystring.stringify(options)
  return {
    types: types.LOAD_MORE_EVENTS,
    promise: fetch(`${API_HOSTNAME}/v1/eventmina?${qs}`),
  }
}

export const getEventPromoted = () => ({
  types: types.GET_EVENT_PROMOTED,
  promise: fetch(`${API_HOSTNAME}/v1/eventmina/promoted?limit=3`),
})

export const getEventDetail = slug => ({
  types: types.GET_EVENT_DETAIL,
  promise: fetch(`${API_HOSTNAME}/v1/eventmina/${slug}`),
})

export const getOtherEvents = slug => ({
  types: types.GET_OTHER_EVENTS,
  promise: fetch(`${API_HOSTNAME}/v1/eventmina/${slug}/other`),
})

export const getEventFilter = page => ({
  types: types.GET_FILTER_EVENT,
  promise: fetch(`${API_HOSTNAME}/v1/category/${page}/event/filter`, opts),
})

export const getEventCategories = () => ({
  types: types.GET_EVENT_CATEGORIES,
  promise: fetch(`${API_HOSTNAME}/v1/eventmina/all_category`),
})

export const likeEvent = (eventSlug) => {
  const token = cookies.get('TKN_MINAPOLI')
  const likeOptions = {
    ...opts,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: querystring.stringify({ type: 'like' }),
  }

  return {
    types: types.LIKE_EVENT,
    event: eventSlug,
    promise: fetch(`${API_HOSTNAME}/v1/eventmina/${eventSlug}/like`, likeOptions),
  }
}



// WEBPACK FOOTER //
// ./src/modules/Event/actions.js